import { GetVoicemailBoxesResponse, VoicEmailsObj, voiceMailRequest, voiceMailResponse } from "../types/voiceMail/apiRequestTypes"

export interface VoiceMailState {

    getVoiceMailsPending: boolean;
    getVoiceMailsSuccess: boolean;
    getVoiceMailsError: string | null;
    data: {},
    IsLastPage: boolean

    setHeardByVoicEmailIdPending: boolean;
    setHeardByVoicEmailIdSuccess: boolean;
    setHeardByVoicEmailIdError: string | null;

    moveToTrashVoiceMailPending: boolean;
    moveToTrashVoiceMailSuccess: boolean;
    moveToTrashVoiceMailError: string | null;

    getAudioFileVoiceMailPending: boolean;
    getAudioFileVoiceMailSuccess: boolean;
    getAudioFileVoiceMailError: string | null;
    url: string;

    getVoicemailBoxesPending: boolean;
    getVoicemailBoxesSuccess: boolean;
    getVoicemailBoxesError: string | null;
    list: GetVoicemailBoxesResponse[];




}


//********************************************************************************* */

export interface GetVoiceMailsSuccessPayload {
    params: voiceMailResponse
}
export interface GetVoiceMailsErrorPayLoad {
    error: string
}

//********************************************************************************* */
export interface SetHeardByVoicEmailIdSuccessPayload {

}
export interface SetHeardByVoicEmailIdErrorPayLoad {
    error: string
}
//********************************************************************************* */
export interface MoveToTrashSuccessPayload {
    params: any
}

export interface MoveToTrashErrorPayLoad {
    error: string
}
//********************************************************************************** */
export interface GetAudioFileSuccessPayload {
    params: string
}
export interface GetAudioFileErrorPayload {
    error: string
}
//******************************************************************************* */
export interface GetVoicemailBoxesSuccessPayload {
    params: GetVoicemailBoxesResponse
}
export interface GetVoicemailBoxesErrorPayLoad {
    error: string
}

export class VoiceMail {
    IsLastPage: boolean = false
    Voicemails: VoicEmailsObj[] = []

    mapper(data: any) {
        this.IsLastPage = data?.isLastPage
        data?.voicemailOutputModel?.forEach((element: any) => {
            this.Voicemails.push({
                VoicemailId: element.recordingId,
                Folder: 0,
                CallerNumber: element.callerNumber,
                VoicemailNumber: element.number,
                Duration: element.duration,
                Heard: element.heard,
                Date: element.persianDateTime,
                IsDeleted: element.isDeleted
            })
        });

    }


}
export interface VoiceMailUrlPayloadType {
    lineId: string,
    url: string
}
